import { ProcedureType } from "../../../../../autogen/bff-api";

// Mirrors ProcedureType.isTwoStage in the BFF: procedures with a prequalification round
// (forespørsel om å delta → kvalifiser → inviter) before the tender phase.
export const TWO_STAGE_PROCEDURES: ReadonlySet<ProcedureType> = new Set([
  ProcedureType.Restricted,
  ProcedureType.NegotiatedWithPriorCall,
  ProcedureType.CompetitiveDialogue,
  ProcedureType.InnovationPartnership,
  ProcedureType.CompetitiveNegotiation,
  ProcedureType.DynamicPurchasingSystem,
]);

export const isTwoStageProcedure = (procedureType: ProcedureType | null | undefined): boolean =>
  procedureType != null && TWO_STAGE_PROCEDURES.has(procedureType);

// The system itself (FOA kap. 26) — announced once, then open for its whole validity.
export const isDpsScheme = (procedureType: ProcedureType | null | undefined): boolean =>
  procedureType === ProcedureType.DynamicPurchasingSystem;

// One purchase under the system (§ 26-7) — invited-only, never announced.
export const isDpsCompetition = (procedureType: ProcedureType | null | undefined): boolean =>
  procedureType === ProcedureType.DpsCompetition;

// § 26-7: the announcement of the system settled classification, regime and scope for every
// purchase under it, so the purchase asks for none of it again.
export const inheritsScopeFromScheme = (procedureType: ProcedureType | null | undefined): boolean =>
  isDpsCompetition(procedureType);

// A system signs nothing itself — the contract period belongs to each purchase under it.
export const signsItsOwnContract = (procedureType: ProcedureType | null | undefined): boolean =>
  !isDpsScheme(procedureType);

// Mirrors SourcingEventV2.hasTenderStageQualification in the BFF: single-stage public procedures
// have no prequalification round, so the suppliers are qualified on their tenders before the
// evaluation opens.
export const hasTenderStageQualification = (
  procedureType: ProcedureType | null | undefined,
): boolean => procedureType != null && !TWO_STAGE_PROCEDURES.has(procedureType);

// Mirrors ProcedureType.allowsNegotiation in the BFF: FOA § 23-6 bars negotiation and revised
// tenders in the anbudskonkurransene (åpen and begrenset).
export const NEGOTIATING_PROCEDURES: ReadonlySet<ProcedureType> = new Set([
  ProcedureType.NegotiatedWithPriorCall,
  ProcedureType.NegotiatedWithoutPriorCall,
  ProcedureType.CompetitiveDialogue,
  ProcedureType.InnovationPartnership,
  ProcedureType.CompetitiveNegotiation,
]);

export const allowsNegotiation = (procedureType: ProcedureType | null | undefined): boolean =>
  procedureType != null && NEGOTIATING_PROCEDURES.has(procedureType);
